export enum BannerType {
  Success = 'success',
  Disaster = 'error',
  Info = 'info',
}

export enum BannerSize {
  SM = 'sm',
  MD = 'md',
}